/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateCaseNoteByCase = /* GraphQL */ `subscription OnCreateCaseNoteByCase($caseID: ID!, $userGroup: UserGroup!) {
  onCreateCaseNoteByCase(caseID: $caseID, userGroup: $userGroup) {
    id
    createdAt
    postDate
    authorID
    authorEmployerID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    isPinned
    note
    caseID
    processRequestID
    companyID
    userGroup
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCaseNoteByCaseSubscriptionVariables,
  APITypes.OnCreateCaseNoteByCaseSubscription
>;
export const onCreateCaseNoteByProcessRequest = /* GraphQL */ `subscription OnCreateCaseNoteByProcessRequest(
  $processRequestID: ID!
  $userGroup: UserGroup!
) {
  onCreateCaseNoteByProcessRequest(
    processRequestID: $processRequestID
    userGroup: $userGroup
  ) {
    id
    createdAt
    postDate
    authorID
    authorEmployerID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    isPinned
    note
    caseID
    processRequestID
    companyID
    userGroup
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCaseNoteByProcessRequestSubscriptionVariables,
  APITypes.OnCreateCaseNoteByProcessRequestSubscription
>;
export const onUpdateCaseNoteByCase = /* GraphQL */ `subscription OnUpdateCaseNoteByCase($caseID: ID!, $userGroup: UserGroup!) {
  onUpdateCaseNoteByCase(caseID: $caseID, userGroup: $userGroup) {
    id
    createdAt
    postDate
    authorID
    authorEmployerID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    isPinned
    note
    caseID
    processRequestID
    companyID
    userGroup
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCaseNoteByCaseSubscriptionVariables,
  APITypes.OnUpdateCaseNoteByCaseSubscription
>;
export const onUpdateCaseNoteByProcessRequest = /* GraphQL */ `subscription OnUpdateCaseNoteByProcessRequest(
  $processRequestID: ID!
  $userGroup: UserGroup!
) {
  onUpdateCaseNoteByProcessRequest(
    processRequestID: $processRequestID
    userGroup: $userGroup
  ) {
    id
    createdAt
    postDate
    authorID
    authorEmployerID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    isPinned
    note
    caseID
    processRequestID
    companyID
    userGroup
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCaseNoteByProcessRequestSubscriptionVariables,
  APITypes.OnUpdateCaseNoteByProcessRequestSubscription
>;
export const onDeleteCaseNoteByCase = /* GraphQL */ `subscription OnDeleteCaseNoteByCase($caseID: ID!, $userGroup: UserGroup!) {
  onDeleteCaseNoteByCase(caseID: $caseID, userGroup: $userGroup) {
    id
    createdAt
    postDate
    authorID
    authorEmployerID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    isPinned
    note
    caseID
    processRequestID
    companyID
    userGroup
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCaseNoteByCaseSubscriptionVariables,
  APITypes.OnDeleteCaseNoteByCaseSubscription
>;
export const onDeleteCaseNoteByProcessRequest = /* GraphQL */ `subscription OnDeleteCaseNoteByProcessRequest(
  $processRequestID: ID!
  $userGroup: UserGroup!
) {
  onDeleteCaseNoteByProcessRequest(
    processRequestID: $processRequestID
    userGroup: $userGroup
  ) {
    id
    createdAt
    postDate
    authorID
    authorEmployerID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    isPinned
    note
    caseID
    processRequestID
    companyID
    userGroup
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCaseNoteByProcessRequestSubscriptionVariables,
  APITypes.OnDeleteCaseNoteByProcessRequestSubscription
>;
export const onCreateComment = /* GraphQL */ `subscription OnCreateComment($sourceID: ID!) {
  onCreateComment(sourceID: $sourceID) {
    createdAt
    authorID
    authorEmployerID
    authorForeignNationalID
    authorTeamMemberID
    authorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    authorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    authorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    note
    sourceID
    id
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCommentSubscriptionVariables,
  APITypes.OnCreateCommentSubscription
>;
export const onCreateNotification = /* GraphQL */ `subscription OnCreateNotification($personID: ID) {
  onCreateNotification(personID: $personID) {
    id
    createdAt
    updatedAt
    personID
    activityID
    activity {
      id
      createdAt
      updatedAt
      activityType
      ipAddress
      fieldName
      updatedValue
      actorID
      actorEmployerID
      actorForeignNationalID
      actorTeamMemberID
      actorType
      directTargetID
      directTargetCaseID
      directTargetCompanyID
      directTargetEmployerID
      directTargetFileDataID
      directTargetForeignNationalID
      directTargetProcessRequestID
      directTargetTaskID
      directTargetTeamMemberID
      directTargetReportID
      targetString
      indirectTargetID
      indirectTargetCaseID
      indirectTargetCompanyID
      indirectTargetEmployerID
      indirectTargetForeignNationalID
      indirectTargetProcessRequestID
      indirectTargetTeamMemberID
      indirectTargetReportID
      indirectTargetString
      ownerID
      ownerCaseID
      ownerCompanyID
      ownerEmployerID
      ownerFileDataID
      ownerForeignNationalID
      ownerProcessRequestID
      ownerTeamMemberID
      ownerReportID
      __typename
    }
    read
    personNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    personEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    personTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateNotificationSubscriptionVariables,
  APITypes.OnCreateNotificationSubscription
>;
export const onUpdateFileData = /* GraphQL */ `subscription OnUpdateFileData($id: ID!) {
  onUpdateFileData(id: $id) {
    id
    expirationDate
    durationOfStatus
    fileName
    original {
      bucket
      region
      key
      level
      identityId
      __typename
    }
    fileType
    fileRequirement
    fileCategory
    contentType
    issueDate
    dueDate
    isFlattened
    processRequestID
    companyID
    ownerNationalID
    sourceID
    uploadDate
    uploaderID
    uploaderEmployerID
    uploaderForeignNationalID
    uploaderTeamMemberID
    uploaderForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    uploaderTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    uploaderEmployer {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    cases {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateFileDataSubscriptionVariables,
  APITypes.OnUpdateFileDataSubscription
>;
export const onUpdateCompany = /* GraphQL */ `subscription OnUpdateCompany($id: ID!) {
  onUpdateCompany(id: $id) {
    id
    name
    lowerName
    lowerNameKey
    displayCompanyName
    slug
    type
    logo {
      version
      __typename
    }
    domainWhitelist
    onboardingSections {
      companyInfo
      contactInfo
      companyPreferences
      immigrationPreferences
      paymentPreferences
      questions
      employeeInformation
      __typename
    }
    hasCompletedOnboardingQuestions
    completedOnboardingQuestionsBy
    isPartnerCompany
    isParent
    children {
      nextToken
      __typename
    }
    parent {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    parentID
    archived
    companyNumber
    nationalCount
    foreignNationals {
      nextToken
      __typename
    }
    assignedAttorneys {
      nextToken
      __typename
    }
    assignedParalegals {
      nextToken
      __typename
    }
    accountManagerID
    accountManager {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    assignedEmployers {
      nextToken
      __typename
    }
    assignedEmployerAdmins {
      nextToken
      __typename
    }
    invoicingContacts {
      nextToken
      __typename
    }
    primaryContacts {
      nextToken
      __typename
    }
    seniorContacts {
      nextToken
      __typename
    }
    signatoryContacts {
      nextToken
      __typename
    }
    data {
      id
      companyID
      preferredMailingAddress
      companyNameShowToFN
      companyCoversExpenseOfDependentPetitionsAndOrEADCards
      doingBusinessAs
      educationEvaluation
      employeesEmailMHAttorneysAndParalegalsDirectly
      fein
      fullTimeEmployeesInUS
      isH1BDependentEmloyer
      hasBeenWillfulViolator
      isHigherEd_20_USC_1001_a
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4
      maintainsAWrittenImmigrationPolicy
      naicsCodeOfCompany
      partTimeEmployeesInUS
      paymentPreference
      permissionPowerAttorney
      permissionReleaseApprovalNotices
      permissionReleasePetitionsRFE
      permissionReleaseLCA
      permissionRelease9089
      phone
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime
      fax
      preferredShippingSpeedForDocuments
      shipOriginalApprovalNotices
      staffsEmployeesAtThirdPartyEndClientSites
      typeOfBusiness
      usesWageSurvey
      usesEVerify
      utilizePremiumProcessingService
      technologyReleaseLicenseRequirement
      yearCompanyWasFoundedInUS
      I9_audit_has_been_completed_in_past_18_months
      current_number_of_H1B_employees
      current_number_of_employees_on_L_visas
      other_visa_statuses_sponsored
      email_address_invoices_should_be_addressed_to
      name_invoices_should_be_addressed_to
      companyCoversExpenseOfDependentPetitions
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime
      annualMeetingDate
      requiresMeetingReminder
      createdAt
      updatedAt
      __typename
    }
    processRequests {
      nextToken
      __typename
    }
    jobDescriptions {
      nextToken
      __typename
    }
    files {
      nextToken
      __typename
    }
    fileRequirements {
      type
      fileType
      fileCategory
      fileInstruction
      defaultStorage
      visibility
      assignedToID
      isAssignedToLegalAssistants
      expirationDateRequired
      issueDateRequired
      dueDateRequired
      isApproved
      isRequested
      hidden
      durationOfStatus
      __typename
    }
    cases {
      nextToken
      __typename
    }
    openCaseCount
    closedCaseCount
    completedCaseCount
    legalTeamIDs
    notes
    petitionerParagraph
    reportEntries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    companyDataId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCompanySubscriptionVariables,
  APITypes.OnUpdateCompanySubscription
>;
export const onUpdatePreparedForm = /* GraphQL */ `subscription OnUpdatePreparedForm($id: ID!) {
  onUpdatePreparedForm(id: $id) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    companyID
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    relativeAdmins
    state
    preparerID
    preparer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    templateID
    template {
      id
      name
      processes
      archived
      updatedAt
      requiresAttorneyApproval
      requiresSponsorApproval
      requiresNationalApproval
      employersCanView
      nationalsCanView
      __typename
    }
    completedFormID
    completedForm {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    completedFormHistory {
      nextToken
      __typename
    }
    assignedToID
    assignedToEmployerID
    assignedToNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    rejectedDate
    rejectedByID
    rejectedByEmployerID
    rejectedByNationalID
    rejectedByTeamMemberID
    rejectedByEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    rejectedByNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    rejectedByTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    requiresAttorneyApproval
    attorneyApproverID
    attorneyApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    attorneyApprovalDate
    requiresSponsorApproval
    sponsorApproverID
    sponsorApproverEmployerID
    sponsorApproverNationalID
    sponsorApproverEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    sponsorApproverNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    sponsorApprovalDate
    requiresNationalApproval
    nationalApproverID
    nationalApprover {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    nationalApprovalDate
    finalCaseManagerApproverID
    finalCaseManagerApprover {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    finalCaseManagerApprovalDate
    employersCanView
    nationalsCanView
    createdAt
    updatedAt
    comments {
      nextToken
      __typename
    }
    activities {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePreparedFormSubscriptionVariables,
  APITypes.OnUpdatePreparedFormSubscription
>;
export const onCreateActivityByIndirectTargetID = /* GraphQL */ `subscription OnCreateActivityByIndirectTargetID($indirectTargetID: ID) {
  onCreateActivityByIndirectTargetID(indirectTargetID: $indirectTargetID) {
    id
    createdAt
    updatedAt
    activityType
    ipAddress
    fieldName
    updatedValue
    actorID
    actorEmployerID
    actorForeignNationalID
    actorTeamMemberID
    actorType
    actorEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    actorForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    actorTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    directTargetID
    directTargetCaseID
    directTargetCompanyID
    directTargetEmployerID
    directTargetFileDataID
    directTargetForeignNationalID
    directTargetProcessRequestID
    directTargetTaskID
    directTargetTeamMemberID
    directTargetReportID
    targetString
    targetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    targetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    targetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    targetFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    targetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    targetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    targetTask {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    targetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    targetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    indirectTargetID
    indirectTargetCaseID
    indirectTargetCompanyID
    indirectTargetEmployerID
    indirectTargetForeignNationalID
    indirectTargetProcessRequestID
    indirectTargetTeamMemberID
    indirectTargetReportID
    indirectTargetString
    indirectTargetCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    indirectTargetCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    indirectTargetEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    indirectTargetForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    indirectTargetProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    indirectTargetTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    indirectTargetReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    ownerID
    ownerCaseID
    ownerCompanyID
    ownerEmployerID
    ownerFileDataID
    ownerForeignNationalID
    ownerProcessRequestID
    ownerTeamMemberID
    ownerReportID
    ownerCase {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    ownerCompany {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    ownerEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    ownerFileData {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    ownerForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    ownerProcessRequest {
      id
      assignedToID
      assignedToEmployerID
      assignedToTeamMemberID
      companyID
      individualSponsored
      initiatorID
      jobDescriptionID
      requesterID
      requestDate
      approvalDate
      archivedDate
      cancelDate
      foreignNationalID
      needsEmployerRevision
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      slug
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      createdAt
      updatedAt
      __typename
    }
    ownerTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    ownerReport {
      id
      templateID
      companyIds
      accessibleIds
      editableIds
      viewAccess
      editAccess
      type
      name
      status
      numberOfFilters
      numberOfColumns
      fromTemplate
      totalCountCycle
      completedCountCycle
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateActivityByIndirectTargetIDSubscriptionVariables,
  APITypes.OnCreateActivityByIndirectTargetIDSubscription
>;
export const onCreateCaseFile = /* GraphQL */ `subscription OnCreateCaseFile($caseID: ID!) {
  onCreateCaseFile(caseID: $caseID) {
    id
    fileID
    caseID
    file {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCaseFileSubscriptionVariables,
  APITypes.OnCreateCaseFileSubscription
>;
export const onDeleteCaseFile = /* GraphQL */ `subscription OnDeleteCaseFile($caseID: ID!) {
  onDeleteCaseFile(caseID: $caseID) {
    id
    fileID
    caseID
    file {
      id
      expirationDate
      durationOfStatus
      fileName
      fileType
      fileRequirement
      fileCategory
      contentType
      issueDate
      dueDate
      isFlattened
      processRequestID
      companyID
      ownerNationalID
      sourceID
      uploadDate
      uploaderID
      uploaderEmployerID
      uploaderForeignNationalID
      uploaderTeamMemberID
      createdAt
      updatedAt
      __typename
    }
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCaseFileSubscriptionVariables,
  APITypes.OnDeleteCaseFileSubscription
>;
export const onUpdateTask = /* GraphQL */ `subscription OnUpdateTask($id: ID!) {
  onUpdateTask(id: $id) {
    id
    action
    isKeyDate
    keyDateAlternateAction
    isPaymentStatus
    paymentStatusAlternateAction
    assignedToID
    isAssignedToLegalAssistants
    assignedToEmployerID
    assignedToForeignNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    caseState
    category
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    comments {
      nextToken
      __typename
    }
    completeDate
    deadline
    deadlineIsManuallySet
    deleteDate
    deleteReason
    dependencies {
      nextToken
      __typename
    }
    description
    duration
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    groupsCanRead
    isCustom
    isManuallyUnlocked
    prerequisite {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    prerequisiteID
    startDate
    state
    templateID
    assigneeLowerName
    attorneyLowerFirstName
    attorneyLowerName
    paralegalLowerName
    paralegalLowerFirstName
    companyLowerName
    nationalLowerName
    orderIndex
    defaultAssignee
    createdAt
    updatedAt
    foreignNationalTasksId
    employerTasksId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTaskSubscriptionVariables,
  APITypes.OnUpdateTaskSubscription
>;
export const onUpdateTaskByCaseID = /* GraphQL */ `subscription OnUpdateTaskByCaseID($caseID: ID!) {
  onUpdateTaskByCaseID(caseID: $caseID) {
    id
    action
    isKeyDate
    keyDateAlternateAction
    isPaymentStatus
    paymentStatusAlternateAction
    assignedToID
    isAssignedToLegalAssistants
    assignedToEmployerID
    assignedToForeignNationalID
    assignedToTeamMemberID
    assignedToEmployer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    assignedToForeignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    assignedToTeamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    caseState
    category
    companyID
    company {
      id
      name
      lowerName
      lowerNameKey
      displayCompanyName
      slug
      type
      domainWhitelist
      hasCompletedOnboardingQuestions
      completedOnboardingQuestionsBy
      isPartnerCompany
      isParent
      parentID
      archived
      companyNumber
      nationalCount
      accountManagerID
      openCaseCount
      closedCaseCount
      completedCaseCount
      legalTeamIDs
      notes
      petitionerParagraph
      createdAt
      updatedAt
      companyDataId
      __typename
    }
    comments {
      nextToken
      __typename
    }
    completeDate
    deadline
    deadlineIsManuallySet
    deleteDate
    deleteReason
    dependencies {
      nextToken
      __typename
    }
    description
    duration
    foreignNationalID
    foreignNational {
      type
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      completedOnboardingQuestionsBy
      email
      emailPersonal
      emailWork
      username
      firstname
      middlename
      lastname
      nickname
      employeeId
      additionalFirstnames
      additionalMiddlenames
      additionalLastnames
      lowerFirst
      lowerLast
      lowerFull
      maritalStatus
      spouse
      dependents
      phone
      phoneWork
      companyID
      companyNationalNumber
      mostRecentlyInvited
      archived
      relatives
      relativeAdmins
      immigrationVisaStatus
      visaExpiration
      nonImmigrantVisaNumber
      visaIssueDate
      visaConsulate
      immigrantVisaApplicant
      immigrantPetitionEverFiled
      hasPendingETA9089
      aosFilingEligible
      hasValidOrExpiredEAD
      hasPendingUSCISApplication
      hasHadVisaPetitionRevokedOrDenied
      hasBeenArrestedSinceLastUSEntry
      hasTransportedWeapons
      hasParticipatedInArmedGroup
      hasDetailedPerson
      hasUsedWeapons
      hasWeaponsTraining
      hasCriminalOffence
      hasViolatedVisaTerms
      citizenshipCountry
      birthCountry
      birthState
      birthDate
      birthCity
      jobDescriptionID
      nivMaxout
      isRemote
      hasNonUSPassport
      passportGender
      passportIssueDate
      passportExpirationDate
      passportExpirationReminderSentForDate
      passportNumber
      passportCountry
      usSSN
      hasSSN
      aNumber
      lastEntryUS
      i94ArrivalDepartureRecordNumber
      sevisNumber
      eadNumber
      fileRequirementsManipulated
      test
      notes
      companyName
      immigrationCurrentStatus
      immigrationStatusExpiration
      employmentBasedCategory
      priorityDate
      eadExpDate
      I797ExpDate
      visaExpDate
      chargeabilityCountry
      birthCountryCode
      socCode
      firstEntryUS
      taxTrackingF1J1
      citizenshipEligibilityDate
      startDate
      legalTeamIDs
      createdAt
      updatedAt
      __typename
    }
    groupsCanRead
    isCustom
    isManuallyUnlocked
    prerequisite {
      id
      action
      isKeyDate
      keyDateAlternateAction
      isPaymentStatus
      paymentStatusAlternateAction
      assignedToID
      isAssignedToLegalAssistants
      assignedToEmployerID
      assignedToForeignNationalID
      assignedToTeamMemberID
      caseID
      caseState
      category
      companyID
      completeDate
      deadline
      deadlineIsManuallySet
      deleteDate
      deleteReason
      description
      duration
      foreignNationalID
      groupsCanRead
      isCustom
      isManuallyUnlocked
      prerequisiteID
      startDate
      state
      templateID
      assigneeLowerName
      attorneyLowerFirstName
      attorneyLowerName
      paralegalLowerName
      paralegalLowerFirstName
      companyLowerName
      nationalLowerName
      orderIndex
      defaultAssignee
      createdAt
      updatedAt
      foreignNationalTasksId
      employerTasksId
      __typename
    }
    prerequisiteID
    startDate
    state
    templateID
    assigneeLowerName
    attorneyLowerFirstName
    attorneyLowerName
    paralegalLowerName
    paralegalLowerFirstName
    companyLowerName
    nationalLowerName
    orderIndex
    defaultAssignee
    createdAt
    updatedAt
    foreignNationalTasksId
    employerTasksId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTaskByCaseIDSubscriptionVariables,
  APITypes.OnUpdateTaskByCaseIDSubscription
>;
export const onDeleteReport = /* GraphQL */ `subscription OnDeleteReport($reportID: ID!) {
  onDeleteReport(reportID: $reportID) {
    id
    templateID
    template {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    customTemplate {
      id
      teamMemberId
      employerID
      accessibleIds
      editableIds
      name
      selectedFields
      includeFN
      individualFNCase
      includeCases
      numberOfFilters
      numberOfColumns
      type
      category
      isDeleted
      viewAccess
      editAccess
      accessibleCompanyIds
      companyIds
      createdAt
      updatedAt
      __typename
    }
    reportEntries {
      nextToken
      __typename
    }
    companyIds
    accessibleIds
    editableIds
    viewAccess
    editAccess
    type
    name
    status
    numberOfFilters
    numberOfColumns
    fromTemplate
    totalCountCycle
    completedCountCycle
    isCurrent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteReportSubscriptionVariables,
  APITypes.OnDeleteReportSubscription
>;
export const onDeleteTemplate = /* GraphQL */ `subscription OnDeleteTemplate($templateID: ID!) {
  onDeleteTemplate(templateID: $templateID) {
    id
    teamMemberId
    teamMember {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      phone
      position
      title
      licensingAuthority
      stateBarNumber
      isAdmin
      managerID
      mostRecentlyInvited
      archived
      recentlyViewedCases
      nationalsWithOpenCases
      companiesAssignedTo
      createdAt
      updatedAt
      __typename
    }
    employerID
    employer {
      id
      createdBy
      slug
      userAgreementAcknowledged
      userAgreementAcknowledgementDate
      userAgreementAcknowledgementText
      hasLoggedIn
      type
      email
      personalEmail
      newsletterModalViewCount
      username
      firstname
      middlename
      lastname
      lowerFirst
      lowerLast
      lowerFull
      address
      phone
      personalPhone
      title
      companyIDs
      hasCompletedOnboardingQuestions
      recentlyViewedCases
      mostRecentlyInvited
      archived
      invoicingContactCompanyIDs
      isInvoicingContact
      primaryContactCompanyIDs
      isPrimaryContact
      seniorContactCompanyIDs
      isSeniorContact
      signatoryContactCompanyIDs
      isSignatoryContact
      assignedCaseIDs
      nationalsWithOpenCases
      createdAt
      updatedAt
      __typename
    }
    reports {
      nextToken
      __typename
    }
    templateReports {
      nextToken
      __typename
    }
    accessibleIds
    editableIds
    name
    selectedFields
    includeFN
    individualFNCase
    includeCases
    numberOfFilters
    numberOfColumns
    type
    category
    isDeleted
    viewAccess
    editAccess
    accessibleCompanyIds
    companyIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTemplateSubscriptionVariables,
  APITypes.OnDeleteTemplateSubscription
>;
export const onCreateAdditionalFields = /* GraphQL */ `subscription OnCreateAdditionalFields(
  $filter: ModelSubscriptionAdditionalFieldsFilterInput
) {
  onCreateAdditionalFields(filter: $filter) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAdditionalFieldsSubscriptionVariables,
  APITypes.OnCreateAdditionalFieldsSubscription
>;
export const onUpdateAdditionalFields = /* GraphQL */ `subscription OnUpdateAdditionalFields(
  $filter: ModelSubscriptionAdditionalFieldsFilterInput
) {
  onUpdateAdditionalFields(filter: $filter) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAdditionalFieldsSubscriptionVariables,
  APITypes.OnUpdateAdditionalFieldsSubscription
>;
export const onDeleteAdditionalFields = /* GraphQL */ `subscription OnDeleteAdditionalFields(
  $filter: ModelSubscriptionAdditionalFieldsFilterInput
) {
  onDeleteAdditionalFields(filter: $filter) {
    id
    caseID
    case {
      id
      caseNumber
      slug
      attorneyID
      caseManagerID
      complianceListID
      PERMFilingDataID
      pinnedCaseNoteID
      contributorIds
      sponsoringEmployerID
      sponsoringNationalID
      foreignNationalID
      welcomeLetterAcknowledged
      welcomeLetterAcknowledgementDate
      welcomeLetterAcknowledgedBy
      welcomeLetterText
      nationalVisaExpiration
      relativeAdmins
      startDate
      closeDate
      closeReason
      completeDate
      sourceID
      state
      lowerNationalName
      lowerCompanyName
      lowerProcessType
      currentPhase
      prevailingWageCaseNumber
      USCISReceiptNumber
      AOSReceiptNotice
      I485JReceiptNotice
      SelectionNoticeNo
      ETACaseNumber
      isShipmentTrackingElectronically
      companyID
      individualSponsored
      jobDescriptionID
      resumeID
      requestedProcess
      requestedProcessSubCategory
      requestedProcessAdditionalProcessing
      globalRequestedProcessSubCategory
      globalProcessCountryCode
      globalProcessDuration
      globalVisaType
      vendorID
      additionalFieldID
      createdAt
      updatedAt
      __typename
    }
    fields
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAdditionalFieldsSubscriptionVariables,
  APITypes.OnDeleteAdditionalFieldsSubscription
>;
export const onCreateScheduler = /* GraphQL */ `subscription OnCreateScheduler($filter: ModelSubscriptionSchedulerFilterInput) {
  onCreateScheduler(filter: $filter) {
    id
    name
    eventBridgeschedulerName
    eventBridgeSchedulerID
    description
    schedulerExpression
    endDate
    startTime
    frequencyNumber
    frequencyUnit
    startDate
    timeZone
    targetUrl
    entityID
    taskDefinitionID
    taskDefinition {
      id
      taskType
      payload
      recipientIDs
      companyIndividualIDs
      individualIDs
      companyIDs
      updatedAt
      createdAt
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSchedulerSubscriptionVariables,
  APITypes.OnCreateSchedulerSubscription
>;
export const onUpdateScheduler = /* GraphQL */ `subscription OnUpdateScheduler($filter: ModelSubscriptionSchedulerFilterInput) {
  onUpdateScheduler(filter: $filter) {
    id
    name
    eventBridgeschedulerName
    eventBridgeSchedulerID
    description
    schedulerExpression
    endDate
    startTime
    frequencyNumber
    frequencyUnit
    startDate
    timeZone
    targetUrl
    entityID
    taskDefinitionID
    taskDefinition {
      id
      taskType
      payload
      recipientIDs
      companyIndividualIDs
      individualIDs
      companyIDs
      updatedAt
      createdAt
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSchedulerSubscriptionVariables,
  APITypes.OnUpdateSchedulerSubscription
>;
export const onDeleteScheduler = /* GraphQL */ `subscription OnDeleteScheduler($filter: ModelSubscriptionSchedulerFilterInput) {
  onDeleteScheduler(filter: $filter) {
    id
    name
    eventBridgeschedulerName
    eventBridgeSchedulerID
    description
    schedulerExpression
    endDate
    startTime
    frequencyNumber
    frequencyUnit
    startDate
    timeZone
    targetUrl
    entityID
    taskDefinitionID
    taskDefinition {
      id
      taskType
      payload
      recipientIDs
      companyIndividualIDs
      individualIDs
      companyIDs
      updatedAt
      createdAt
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteSchedulerSubscriptionVariables,
  APITypes.OnDeleteSchedulerSubscription
>;
export const onCreateVendor = /* GraphQL */ `subscription OnCreateVendor($filter: ModelSubscriptionVendorFilterInput) {
  onCreateVendor(filter: $filter) {
    id
    name
    type
    location
    email
    lowerName
    processRequests {
      nextToken
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateVendorSubscriptionVariables,
  APITypes.OnCreateVendorSubscription
>;
export const onUpdateVendor = /* GraphQL */ `subscription OnUpdateVendor($filter: ModelSubscriptionVendorFilterInput) {
  onUpdateVendor(filter: $filter) {
    id
    name
    type
    location
    email
    lowerName
    processRequests {
      nextToken
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVendorSubscriptionVariables,
  APITypes.OnUpdateVendorSubscription
>;
export const onDeleteVendor = /* GraphQL */ `subscription OnDeleteVendor($filter: ModelSubscriptionVendorFilterInput) {
  onDeleteVendor(filter: $filter) {
    id
    name
    type
    location
    email
    lowerName
    processRequests {
      nextToken
      __typename
    }
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteVendorSubscriptionVariables,
  APITypes.OnDeleteVendorSubscription
>;
export const onCreateTaskDefinition = /* GraphQL */ `subscription OnCreateTaskDefinition(
  $filter: ModelSubscriptionTaskDefinitionFilterInput
) {
  onCreateTaskDefinition(filter: $filter) {
    id
    taskType
    scheduler {
      id
      name
      eventBridgeschedulerName
      eventBridgeSchedulerID
      description
      schedulerExpression
      endDate
      startTime
      frequencyNumber
      frequencyUnit
      startDate
      timeZone
      targetUrl
      entityID
      taskDefinitionID
      updatedAt
      createdAt
      __typename
    }
    payload
    recipientIDs
    companyIndividualIDs
    individualIDs
    companyIDs
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTaskDefinitionSubscriptionVariables,
  APITypes.OnCreateTaskDefinitionSubscription
>;
export const onUpdateTaskDefinition = /* GraphQL */ `subscription OnUpdateTaskDefinition(
  $filter: ModelSubscriptionTaskDefinitionFilterInput
) {
  onUpdateTaskDefinition(filter: $filter) {
    id
    taskType
    scheduler {
      id
      name
      eventBridgeschedulerName
      eventBridgeSchedulerID
      description
      schedulerExpression
      endDate
      startTime
      frequencyNumber
      frequencyUnit
      startDate
      timeZone
      targetUrl
      entityID
      taskDefinitionID
      updatedAt
      createdAt
      __typename
    }
    payload
    recipientIDs
    companyIndividualIDs
    individualIDs
    companyIDs
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTaskDefinitionSubscriptionVariables,
  APITypes.OnUpdateTaskDefinitionSubscription
>;
export const onDeleteTaskDefinition = /* GraphQL */ `subscription OnDeleteTaskDefinition(
  $filter: ModelSubscriptionTaskDefinitionFilterInput
) {
  onDeleteTaskDefinition(filter: $filter) {
    id
    taskType
    scheduler {
      id
      name
      eventBridgeschedulerName
      eventBridgeSchedulerID
      description
      schedulerExpression
      endDate
      startTime
      frequencyNumber
      frequencyUnit
      startDate
      timeZone
      targetUrl
      entityID
      taskDefinitionID
      updatedAt
      createdAt
      __typename
    }
    payload
    recipientIDs
    companyIndividualIDs
    individualIDs
    companyIDs
    updatedAt
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTaskDefinitionSubscriptionVariables,
  APITypes.OnDeleteTaskDefinitionSubscription
>;
